
export const CANINE = "CANINE";
export const FELINE = "FELINE";
